// initial state
const state = {
  mobileNavbar: { expanded: false }
};

// getters
const getters = {
  mobileNavbar: state => state.mobileNavbar,
  isExpanded: state => state.mobileNavbar.expanded
};

// actions
const actions = {
  expandNavbar({ commit }) {
    commit("changeMobileNavbar", true);
  },

  contractNavbar({ commit }) {
    commit("changeMobileNavbar", false);
  }
};

// mutations
const mutations = {
  changeMobileNavbar(state, expansion) {
    state.mobileNavbar.expanded = expansion;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
